// "Members at this Address" page (S&R job detail → Consumer → Members). Same endpoints as the Android technician app
// (FamilyMembersDialog: GET api/v3/pro/consumer/member/list). Every call resolves to { ok, body, message } and never throws.
import { apiCall } from "./apiCall";

export const consumerMembersApi = {
  // booking detail (same call as the job detail page) → body.consumer { user_id, full_name, email, phone, … }
  booking: (bookingId) => apiCall("post", "bookings/show", { booking_id: bookingId }),
  // appointment detail (same call as Appointment Details) → body.consumer
  appointment: (id) => apiCall("post", "appointments/view", { id }),
  // Universal Quote detail (same call as Quote Details) → body.consumer
  quote: (id) => apiCall("get", "manual-quote/detail", { manual_quote_id: id }),
  // MemberInfoResource: { member_id, first_name, last_name, phone, relation, is_allowed } — no email / primary flag
  list: (consumerId) => apiCall("get", "consumer/member/list", { consumer_id: consumerId }),
};
